import { z } from 'zod'
import { userProfileSchema } from './user-profile'

/** 使用者資訊 Schema */
export const logoutTypeSchema = z
  .object({
    /** 是否已同意條款 */
    agreeTerms: z.string(),
    /** 錯誤次數 */
    errorCount: z.string(),
    /** 場站 */
    station: z.string()
  })
  .merge(userProfileSchema)

/** 使用者資訊 */
export interface LogoutType extends z.infer<typeof logoutTypeSchema> {}
